(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6804);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6269);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2903);



const Banner = () => {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
    className: "bg-indigo-600",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
      className: "p-3 mx-auto max-w-7xl sm:px-6 lg:px-8",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: "flex flex-wrap justify-between items-center",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
          className: "flex flex-1 items-center w-0",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
            className: "flex p-2 bg-indigo-800 rounded-lg",
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              className: "w-6 h-6 text-white",
              "aria-hidden": "true"
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("p", {
            className: "ml-3 font-medium text-white truncate",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
              className: "md:hidden",
              children: "We announced a new product!"
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
              className: "hidden md:inline",
              children: "Big news! We're excited to announce a brand new product."
            })]
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
          className: "shrink-0 order-3 mt-2 w-full sm:order-2 sm:mt-0 sm:w-auto",
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
            href: "#",
            className: "flex justify-center items-center py-2 px-4 text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50 rounded-md border border-transparent shadow-sm",
            children: "Learn more"
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
          className: "shrink-0 order-2 sm:order-3 sm:ml-3",
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("button", {
            type: "button",
            className: "flex p-2 -mr-1 hover:bg-indigo-500 rounded-md focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
              className: "sr-only",
              children: "Dismiss"
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              className: "w-6 h-6 text-white",
              "aria-hidden": "true"
            })]
          })
        })]
      })
    })
  });
};

/***/ }),

/***/ 577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(3992);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/social/github.svg
var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgGithub = props => /*#__PURE__*/react.createElement("svg", _extends({
  height: 256,
  id: "Layer_1",
  style: {
    enableBackground: "new 0 0 256 256"
  },
  width: 256,
  xmlSpace: "preserve",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".st0{fill:none;stroke:#000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/react.createElement("path", {
  className: "st0",
  d: "M130.164 226.986c63.917-3.557 108.667-52.057 97.259-116.5-9.288-52.47-60.722-87.613-112.739-80.577-52.732 7.132-93.294 55.968-87.298 109.095 5.689 47.857 35.128 70.23 59.685 80.335 5.717 2.353 13.401 5.785 15.997 5.229s1.763-14.95 1.763-21.889c-16 2.459-21.475-3.841-24.875-7.563-3.857-4.222-6.125-8.563-10.063-14.938s-11.063-4.875-11.813-8.563 15-2.688 26.313 11.25c8.188 10.146 16.928 7.089 21.625 4.188a23.954 23.954 0 0 1 1.438-6.188c.967-2.557 3.625-4.104 3.208-5.854-.417-1.75-21.804-.577-34-17.667-8.809-12.344-9.129-26.955-5.667-37.833 2.322-7.297 6.196-12.443 8.833-15.417a27.499 27.499 0 0 1-2.583-11.25 27.539 27.539 0 0 1 2.583-12 46.826 46.826 0 0 1 26.583 9.25 70.705 70.705 0 0 1 21.083-3.667 70.78 70.78 0 0 1 23.667 3.583 41.012 41.012 0 0 1 13.167-7.917 40.83 40.83 0 0 1 11.5-2.417 27.411 27.411 0 0 1 3.167 12.332 27.36 27.36 0 0 1-2.416 11.664c2.867 3.459 7.394 9.875 9.502 18.995.751 3.249 4.857 20.981-6.996 36.24-12.408 15.974-33.06 13.524-33.992 15.73-.932 2.206 3.964 6.297 6.266 14.877 2.302 8.58 1.327 24.979 1.327 24.979"
})));

/* harmony default export */ var github = (SvgGithub);
;// CONCATENATED MODULE: ./public/images/layout/footer-waves.svg
var footer_waves_path;

function footer_waves_extends() { footer_waves_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return footer_waves_extends.apply(this, arguments); }



const SvgFooterWaves = props => /*#__PURE__*/react.createElement("svg", footer_waves_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320"
}, props), footer_waves_path || (footer_waves_path = /*#__PURE__*/react.createElement("path", {
  fill: "#09f",
  d: "m0 288 48-16c48-16 144-48 240-74.7 96-26.3 192-48.3 288-32 96 15.7 192 69.7 288 85.4 96 16.3 192-5.7 288 0 96 5.3 192 37.3 240 53.3l48 16H0Z"
})));

/* harmony default export */ var footer_waves = (SvgFooterWaves);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
;// CONCATENATED MODULE: ./src/components/layout/MainFooter.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






const BgWaved = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(footer_waves,  true ? {
  target: "e1h5tmom1"
} : 0)( true ? {
  name: "15uo8xc",
  styles: "object-fit:cover;position:absolute;width:100%;object-position:center;display:block"
} : 0);

const FooterCtn = (0,emotion_styled_base_browser_esm/* default */.Z)("footer",  true ? {
  target: "e1h5tmom0"
} : 0)( true ? {
  name: "zrfqw1",
  styles: "display:grid;.content,.bgImage{grid-area:1/1;}.bgImage{z-index:-1;}"
} : 0);

const MainFooter = () => {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterCtn, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: 'bgImage',
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BgWaved, {})
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: 'content',
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: 'https://github.com/belgattitude/nextjs-monorepo-example',
        target: '_blank',
        rel: 'noopener noreferrer',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(github, {})
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/layout/MainLayout.tsx



const MainLayout = props => {
  const {
    children
  } = props;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: "flex flex-col h-screen",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
      children: children
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainFooter, {})]
  });
};

/***/ }),

/***/ 4855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ DemoRoute; }
});

;// CONCATENATED MODULE: ../../packages/core-lib/src/index.ts




const sayHello = name => {
  return "I'm the @your-org/ui-lib component telling ".concat(name, " !");
};
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/message.tsx

const Message = ({
  message
}) => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
  children: message
});
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/async-message.tsx



const AsyncMessage = props => {
  const {
    0: msg,
    1: setMsg
  } = (0,react.useState)(null);
  const {
    0: isLoading,
    1: setLoading
  } = (0,react.useState)(true);
  const {
    0: error,
    1: setError
  } = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    setLoading(true);
    fetch(props.apiUrl).then(res => res.text()).then(data => {
      setMsg(data);
      setLoading(false);
    }).catch(err => {
      setError(err instanceof Error ? err.message : 'Unknown error');
      setLoading(false);
    });
  }, [props.apiUrl]);

  if (error) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
      children: ["Error: ", error]
    });
  }

  if (isLoading) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      children: "Loading"
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
    children: msg
  });
};
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 25 modules
var esm = __webpack_require__(5814);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(5351);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Banner.tsx
var Banner = __webpack_require__(8731);
// EXTERNAL MODULE: ./src/components/layout/MainLayout.tsx + 3 modules
var MainLayout = __webpack_require__(577);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js + 20 modules
var Button = __webpack_require__(6760);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Card/Card.js + 3 modules
var Card = __webpack_require__(2847);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CardActions/CardActions.js + 1 modules
var CardActions = __webpack_require__(1266);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(7671);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(4905);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 2 modules
var Typography = __webpack_require__(9825);
;// CONCATENATED MODULE: ./src/features/demo/blocks/demo-mui/DemoMuiBlock.tsx










const MediaCard = () => {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* default */.Z, {
    sx: {
      maxWidth: 345
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardMedia/* default */.Z, {
      component: "img",
      height: "140",
      image: "/images/lizard.webp",
      alt: "green iguana"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContent/* default */.Z, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        gutterBottom: true,
        variant: "h5",
        component: "div",
        children: "Lizard"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        variant: "body2",
        color: "text.secondary",
        children: "Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across all continents except Antarctica"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardActions/* default */.Z, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        size: "small",
        children: "Share"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        size: "small",
        children: "Learn More"
      })]
    })]
  });
};

const DemoMuiBlock = () => {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "lg:container lg:mx-auto",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
        className: "mb-2 text-4xl font-bold",
        children: "Material-ui V5."
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MediaCard, {})]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/react-query/lib/index.mjs + 25 modules
var lib = __webpack_require__(1237);
;// CONCATENATED MODULE: ../../packages/core-lib/src/utils/typeguards.ts
const isIsoDateString = dateStr => {
  if (typeof dateStr !== 'string' || !/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(dateStr)) {
    return false;
  }

  try {
    const d = new Date(dateStr);
    return d.toISOString() === dateStr;
  } catch (e) {
    return false;
  }
};
const isNonEmptyString = (v, trim = true) => {
  return typeof v === 'string' && (trim ? v.trim() : v).length > 0;
};
const isPlainObject = v => {
  return typeof v === 'object' && v !== null && v.constructor === Object && Object.getPrototypeOf(v) === Object.prototype;
};
const isSafeInteger = v => {
  return typeof v === 'number' && Number.isSafeInteger(v);
};
const isParsableNumeric = v => {
  if (typeof v === 'number' && !Number.isNaN(v)) {
    return true;
  }

  if (!isNonEmptyString(v)) {
    return false;
  }

  return !Number.isNaN(Number.parseInt(v, 10) || Number.isNaN(Number.parseFloat(v)));
};
const isParsableSafeInteger = v => {
  const value = typeof v === 'string' && /^-?\d+$/.test(v) ? Number.parseInt(v, 10) : v;
  return isSafeInteger(value);
};
const isHttpStatusCode = v => {
  return isSafeInteger(v) && v < 600 && v >= 100;
};
;// CONCATENATED MODULE: ../../packages/core-lib/src/api/json-api/json-api.typeguard.ts

const isJsonApiResponse = val => {
  return isPlainObject(val) && typeof (val === null || val === void 0 ? void 0 : val.success) === 'boolean';
};
const isJsonApiSuccessResponse = val => {
  return isJsonApiResponse(val) && val.success && 'data' in val;
};
const isJsonApiErrorResponse = val => {
  return isJsonApiResponse(val) && !val.success && 'errors' in val && Array.isArray(val.errors);
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/ky/distribution/index.js + 8 modules
var distribution = __webpack_require__(506);
;// CONCATENATED MODULE: ./src/lib/factory/ky.factory.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


class KyFactory {
  constructor(props) {
    this.props = props;

    (0,defineProperty/* default */.Z)(this, "create", options => {
      const hooks = this.props.onAuthFailure !== undefined ? {
        afterResponse: [async (request, options, response) => {
          const {
            status
          } = response;

          if ([401, 403].includes(status) && this.props.onAuthFailure !== undefined) {
            this.props.onAuthFailure(request, options, response);
          }

          return response;
        }]
      } : {};
      return distribution/* default.create */.ZP.create(_objectSpread(_objectSpread({
        prefixUrl: this.props.baseUrl
      }, options), {}, {
        hooks: hooks
      }));
    });
  }

}
;// CONCATENATED MODULE: ./src/config/ky.ts

const ky = new KyFactory({
  onAuthFailure: (_request, _options, _response) => {
    console.log('do whatever');
  }
}).create({
  timeout: 10000,
  retry: {
    limit: 3,
    statusCodes: [408, 413, 429, 500, 502, 503, 504],
    afterStatusCodes: [413, 429, 503],
    methods: ['get', 'put', 'head', 'delete', 'options', 'trace']
  }
});
;// CONCATENATED MODULE: ./src/features/demo/api/fetch-poems-ky.api.ts


const fetchPoemsWithKy = async () => {
  return ky.get('/api/rest/poem').json().then(resp => {
    if (!isJsonApiSuccessResponse(resp)) {
      throw new Error("Error fetching poems: ".concat(resp.errors));
    }

    return resp.data;
  });
};
;// CONCATENATED MODULE: ../../packages/core-lib/src/utils/random-utils.ts
class RandomUtils {
  /**
   * Returns a random integer between min (inclusive) and max (inclusive).
   * The value is no lower than min (or the next integer greater than min
   * if min isn't an integer) and no greater than max (or the next integer
   * lower than max if max isn't an integer).
   * @link https://stackoverflow.com/questions/1527803/generating-random-whole-numbers-in-javascript-in-a-specific-range/1527820#1527820
   */
  static getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

}
;// CONCATENATED MODULE: ../../packages/core-lib/src/utils/array-utils.ts

class ArrayUtils {
  static getRandom(items) {
    return items[RandomUtils.getRandomInt(0, items.length - 1)];
  }

  static removeItem(arr, item) {
    const index = arr.indexOf(item);

    if (index > -1) {
      arr.splice(index, 1);
    }

    return arr;
  }

}
;// CONCATENATED MODULE: ./src/features/demo/components/PoemCard.tsx


const PoemCard = props => {
  const {
    img,
    content,
    author,
    title,
    keywords,
    defaultImg
  } = props;
  const image = img !== null && img !== void 0 ? img : defaultImg;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: "overflow-hidden max-w-sm rounded shadow-lg",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: "h-56 aspect-w-16 aspect-h-9 lg:aspect-none",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
        className: "object-cover object-center w-full h-full lg:w-full lg:h-full",
        src: image !== null && image !== void 0 ? image : '',
        alt: title
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("article", {
      className: "py-4 px-6 prose",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "mb-2 text-xl font-bold",
        children: title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
        className: "text-indigo-600",
        children: ["By ", author]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        className: "text-base text-gray-700 line-clamp-4",
        children: content
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: "px-6 pt-4 pb-2",
      children: keywords.map(keyword => {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
          className: "inline-block py-1 px-3 mr-2 mb-2 text-sm font-semibold text-gray-700 bg-gray-200 rounded-full",
          children: ["#", keyword]
        }, keyword);
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/features/demo/components/PoemGrid.tsx



const waterImages = new Array(25).fill('').map((img, idx) => {
  const index = String(idx + 1).padStart(2, '0');
  return "/shared-assets/images/water/water-".concat(index, ".jpg");
});
const PoemGrid = props => {
  const {
    poems
  } = props;
  let images = waterImages;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: "flex flex-wrap",
    children: poems.map(poem => {
      var _poem$keywords;

      const randomImg = ArrayUtils.getRandom(images);
      const defaultImg = "/_next/image?url=".concat(encodeURIComponent(randomImg), "&w=640&q=85");
      images = images.length < 1 ? waterImages : ArrayUtils.removeItem(images, randomImg);
      const unsplashImg = "https://source.unsplash.com/random/640x480?".concat(((_poem$keywords = poem.keywords) !== null && _poem$keywords !== void 0 ? _poem$keywords : []).map(keyword => encodeURIComponent(keyword)).join(','));
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "m-2 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PoemCard, {
          title: poem.title,
          content: poem.content,
          author: poem.author,
          keywords: poem.keywords,
          img: unsplashImg,
          defaultImg: defaultImg
        })
      }, "".concat(poem.id));
    })
  });
};
;// CONCATENATED MODULE: ./src/features/demo/blocks/poetry/PoetryBlock.tsx







const PoemGridWithReactQueryAndKy = () => {
  const {
    data,
    isLoading,
    error
  } = (0,lib/* useQuery */.aM)(['posts'], () => fetchPoemsWithKy(), {});

  if (isLoading) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: "Loading..."
    });
  }

  if (error) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: ["Error ", JSON.stringify(error)]
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: data && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PoemGrid, {
      poems: data
    })
  });
};

const PoetryBlock = () => {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "lg:container lg:mx-auto",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
        className: "mb-2 text-4xl font-bold",
        children: "Poetry on the wild."
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        className: "mb-2 text-xl font-bold text-indigo-600",
        children: "Client fetch with ky / react-query from nextjs api, db in supabase.io, connection with prisma. Ui with tailwind"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PoemGridWithReactQueryAndKy, {})]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(3992);
// EXTERNAL MODULE: ../../node_modules/rooks/dist/esm/hooks/useIntervalWhen.js
var useIntervalWhen = __webpack_require__(6373);
;// CONCATENATED MODULE: ./src/features/demo/blocks/jumbotron/Jumbotron.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



 // noinspection CssUnknownTarget




const gradients = {
  sky:  true ? {
    name: "69i7wi",
    styles: "background:linear-gradient(\n      90deg,\n      rgba(33, 169, 192, 1) 0%,\n      rgba(113, 223, 208, 1) 70%,\n      rgba(113, 223, 208, 1) 100%\n    )"
  } : 0,
  orange:  true ? {
    name: "qrqf8c",
    styles: "background:linear-gradient(\n      90deg,\n      rgb(217, 102, 23) 0%,\n      rgb(69, 112, 229) 70%,\n      rgb(127, 151, 249) 100%\n    )"
  } : 0,
  yellow:  true ? {
    name: "g7w9dn",
    styles: "background:linear-gradient(\n      90deg,\n      rgb(155, 235, 16) 0%,\n      rgb(213, 226, 13) 70%,\n      rgb(48, 206, 17) 100%\n    )"
  } : 0,
  violet:  true ? {
    name: "1n08ev1",
    styles: "background:linear-gradient(\n      90deg,\n      rgb(117, 4, 139) 0%,\n      rgb(194, 69, 229) 70%,\n      rgb(252, 14, 174) 100%\n    )"
  } : 0,
  fun:  true ? {
    name: "rbntkw",
    styles: "background-image:url('/images/anims/flow-giphy.webp');background-size:cover"
  } : 0
};

const GradientText = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eh8g4ll0"
} : 0)(props => {
  var _props$bg;

  return gradients[(_props$bg = props === null || props === void 0 ? void 0 : props.bg) !== null && _props$bg !== void 0 ? _props$bg : 'sky'];
}, ";-webkit-background-clip:text;-webkit-text-fill-color:transparent;position:absolute;white-space:pre;&:before{content:' ';}&.fadeIn{opacity:1;transition-property:opacity;transition-duration:1.5s;transition-timing-function:ease-in;}&.fadeOut{opacity:0;transform:translate(100px);transition:all 1.5s ease-out;&:last-of-type{font-size:2em;transition-duration:1s;}}" + ( true ? "" : 0));

const titles = [['Typescript', 'sky'], ['React', 'orange'], ['Nextjs', 'violet'], ['Prisma', 'yellow'], ['Emotion', 'fun']];

var _ref =  true ? {
  name: "3mhjuj",
  styles: "font-weight:bolder;font-size:3em;line-height:1.1em;@media (min-width: 600px){font-size:4em;}"
} : 0;

const Jumbotron = () => {
  const {
    0: count,
    1: setCount
  } = (0,react.useState)(0);
  (0,useIntervalWhen/* useIntervalWhen */.K)(() => {
    setCount(count => count >= titles.length - 1 ? 0 : count + 1);
  }, 3500);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: _ref,
      children: ["One of many possibles", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), " made with", titles.map((title, idx) => {
        const [label, grad] = titles[idx];
        const curr = idx === count;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientText, {
          className: curr ? 'fadeIn' : 'fadeOut',
          bg: grad,
          children: label
        }, grad);
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/features/demo/blocks/index.ts



;// CONCATENATED MODULE: ./src/features/demo/demo.config.ts
const demoConfig = {
  i18nNamespaces: ['common', 'demo']
};
;// CONCATENATED MODULE: ./src/features/demo/pages/DemoPage.tsx












const DemoPage = () => {
  const {
    t
  } = (0,esm/* useTranslation */.$G)(demoConfig.i18nNamespaces);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
      title: t('demo:page.title'),
      description: "Web-app nextjs monorepo example, https://github.com/belgattitude/nextjs-monorepo-example"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainLayout/* MainLayout */.Z, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Banner/* Banner */.j, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
        children: "I'm the web-app"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Jumbotron, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          children: "Foo says: ".concat(sayHello('World'), " from @your-org/core-lib")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Message, {
            message: 'Bar react component from @your-org/ui-lib'
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AsyncMessage, {
            apiUrl: '/api/hello'
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: '/shared-assets/images/nextjs-logo.png',
        alt: 'logo',
        width: 400,
        height: 240
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: 'pt-8'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoMuiBlock, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: 'pt-8'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PoetryBlock, {})]
    })]
  });
};
;// CONCATENATED MODULE: ./src/features/demo/pages/index.ts

;// CONCATENATED MODULE: ./src/pages/index.tsx


var __N_SSG = true;
function DemoRoute(_props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoPage, {});
}

/***/ }),

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4855);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [51,641,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);